import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footerContainer">
      <p className="footerText1">
        Création et collaboration de :<br />
        Louisa Ongenyi et Aurélie Thiré
      </p>
      <p className="footerText2">
        Pour rappel, les informations personnelles que vous pourriez fournir ne
        sont ni vendues ni transmises à des tiers. Les données sont collectées
        uniquement dans le but de vous recontacter si nécessaire et avec votre
        consentement.
      </p>
    </div>
  );
}

export default Footer;
